import artikelauswahlClient from "@/legacy/artikelauswahlClient";
import { webCookie } from "@/lib/cookies";
import { getAuthenticationTicket } from "@/lib/formsAuthentication";
import { WarenkorbTyp, type AddToWarenkorbResult, type WarenkorbOverlayResponse } from "@/lib/models/warenkorb";
import { apiEndpoints, environment } from "@/lib/resources";
import $ from "jquery";

export async function updateWarenkorbOverlay() {
	let data = await getWarenkorbOverlayResponse();

	$("[data-warenkorb-overlay-replaceable]").replaceWith(data.PartialView);
	artikelauswahlClient.AktualisiereMengenAnzeige(WarenkorbTyp.Warenkorb, data.AnzahlPositionen);
	warenkorbOverlayButtonsSichtbarkeitAnpassen(data.AnzahlPositionen);
}

export async function addToWarenkorb(artikelNr: string, menge: number, warenkorbTyp: WarenkorbTyp): Promise<AddToWarenkorbResult> {
	return await $.ajax({
		url: apiEndpoints.warenkorb,
		cache: false,
		headers: {
			[environment.landKuerzelHeaderName]: environment.landKuerzel,
		},
		data: {
			identityCulture: environment.identityCulture,
			warenkorbTyp: warenkorbTyp,
			profileId: webCookie.id,
			authenticationTicket: getAuthenticationTicket(),
			artikelNr,
			menge
		}
	});
}

export async function shareCart(empfaenger: string, absenderName: string, mitteilung: string): Promise<AddToWarenkorbResult> {
	return await $.ajax({
		url: apiEndpoints.shareCart,
		cache: false,
		headers: {
			[environment.landKuerzelHeaderName]: environment.landKuerzel,
		},
		data: {
			identityCulture: environment.identityCulture,
			profileId: webCookie.id,
			authenticationTicket: getAuthenticationTicket(),
			empfaenger: empfaenger,
			absenderName: absenderName,
			mitteilung: mitteilung
		}
	});
}

// Export ist ein Keyword damit man die Funktion in anderen TS Files importieren kann.
// Async wird hier verwendet damit wir await benutzen können.
export async function getWarenkorbOverlayResponse(): Promise<WarenkorbOverlayResponse> {
	// await wird genutzt um auf die Antwort der API warten zu können und mögliche Fehler nach oben weiter gegeben werden.
	return await $.ajax({
		type: "GET",
		url: apiEndpoints.warenkorbOverlay,
		cache: false,
		headers: {
			[environment.landKuerzelHeaderName]: environment.landKuerzel,
		},
		data: {
			profileId: webCookie.id,
			identityCulture: environment.identityCulture,
			authenticationTicket: getAuthenticationTicket(),
			warenkorbTyp: WarenkorbTyp.Warenkorb
		},
	});
}

export function warenkorbOverlayButtonsSichtbarkeitAnpassen(anzahlPositionen: number) {
	const warenkorbOeffnenButton = $(".shopping-cart-overlay__order");
	const warenkorbLeerenButton = $(".shopping-cart-overlay__delete");

	if (anzahlPositionen > 0) {
		warenkorbLeerenButton.show();
		warenkorbOeffnenButton.show();
	}
}
